export default __webpack_public_path__ + "static/belka_rozdzialy_right-6017193a5d4e03c2067e122f029bdc21.png";